import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./app";
import { AuthProvider } from "./auth/auth-provider";
import "./index.css";
import "./components/editor/themes/editor-theme.css";

// Initialize theme before React renders to prevent flash
const initializeTheme = () => {
  const stored = localStorage.getItem("tenet-theme");
  const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const isDark = stored === "dark" || (!stored && systemDark);

  if (isDark) {
    document.documentElement.classList.add("dark");
  }
};

initializeTheme();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
